import { Autocomplete, TextField, Typography } from "@mui/material";
import { Controller, type FieldValues, type Path, useFormContext } from "react-hook-form";
import { type ElementTracking, useElementTracking } from "../../../analytics/analytics";

export type Fonts = {
  webSafe: string[];
  web: string[];
};

export const CeFontDropdown = <TFieldValues extends FieldValues>({
  name,
  label,
  fonts,
  analyticsCategory,
}: {
  name: Path<TFieldValues>;
  label: string;
  fonts: Fonts;
  onChange?: (value: string) => void;
} & ElementTracking): React.JSX.Element => {
  const methods = useFormContext<TFieldValues>();
  const analyticsProps = useElementTracking(analyticsCategory, name, "check");

  const groupBy =
    fonts.web.length > 0
      ? (font: string): string => (fonts.webSafe.includes(font) ? "Web-Safe Fonts" : "Web Fonts")
      : undefined;

  return (
    <Controller
      name={name}
      control={methods.control}
      render={({ field }) => (
        <Autocomplete
          value={field.value}
          onChange={(_, value) => field.onChange(value)}
          options={fonts.webSafe.concat(fonts.web)}
          groupBy={groupBy}
          renderOption={(params, option) => (
            <Typography {...params} sx={{ fontFamily: option }} key={option}>
              {option}
            </Typography>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              label={label}
              placeholder={label}
              fullWidth
              sx={{
                "& .MuiInputBase-input": {
                  fontFamily: field.value || "inherit",
                },
              }}
              {...analyticsProps}
            />
          )}
        />
      )}
    />
  );
};
